export { default } from './InformationCard.container';
